import { AppBar, Toolbar, useTheme } from '@mui/material';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
  accountCompanyInfoAtom,
  userAccountAtom,
} from '../../../models/atoms/account_atoms';
import { useTranslation } from '../../../contexts/TranslationContext';
import { MHMTypography } from '../MHM/MHMTypography';
import { DesktopNavMenu } from './DesktopNavMenu';
import { auth_controller } from '../../../controllers/auth_controller';
import { NavState, navStateAtom } from '../../../models/atoms/ui_atoms';
import { MobileNavMenu } from './MobileNavMenu';

type Props = {
  onLogout(): void;
};

export type NavMenuOption = {
  label: string;
  state: NavState | 'logout';
  onClick(): void;
};

export const NAVBAR_HEIGHT = 60;

export function Navbar({ onLogout }: Props) {
  const companyInfo = useRecoilValue(accountCompanyInfoAtom);
  const setNavState = useSetRecoilState(navStateAtom);
  const { t } = useTranslation();
  const account = useRecoilValue(userAccountAtom);
  const {
    assets: { navbarLogoURL },
  } = useTheme();

  const showAccountPage =
    account !== null && account.permissions.manage_accounts;

  const navMenuOptions: Array<NavMenuOption | null> = [
    {
      state: 'device-metrics',
      label: t('Devices'),
      onClick: () => setNavState('device-metrics'),
    },
    showAccountPage
      ? {
          state: 'accounts-page',
          label: t('Accounts'),
          onClick: () => setNavState('accounts-page'),
        }
      : null,
    {
      state: 'settings-page',
      label: t('Settings'),
      onClick: () => setNavState('settings-page'),
    },
  ];

  if (!localStorage.getItem('webview')) {
    navMenuOptions.push({
      state: 'logout',
      label: t('Logout'),
      onClick: logout,
    });
  }

  function logout() {
    auth_controller.logout();
    window.history.pushState({}, '', '/');
    onLogout();
  }

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          zIndex: theme => theme.zIndex.drawer + 1,
          borderRadius: '0 !important',
        }}
        color="appBarBackground"
      >
        <Toolbar
          sx={{
            height: NAVBAR_HEIGHT,
            minHeight: `${NAVBAR_HEIGHT}px !important`,
            maxHeight: NAVBAR_HEIGHT,
          }}
        >
          <img
            style={{ height: '55px', maxWidth: '60px', objectFit: 'contain' }}
            src={navbarLogoURL}
            alt="Logo"
            onClick={() => setNavState('device-metrics')}
          />
          <MHMTypography
            color="appBarText"
            sx={{
              fontSize: '1.4rem',
              mr: 'auto',
              ml: '0.5rem',
            }}
          >
            {companyInfo ? t('Welcome', { company: companyInfo.name }) : ''}
          </MHMTypography>

          <DesktopNavMenu navMenuOptions={navMenuOptions} />
          <MobileNavMenu navMenuOptions={navMenuOptions} />
        </Toolbar>
      </AppBar>
    </>
  );
}
